import { GridApi } from '@ag-grid-community/core';
import { RefObject, useEffect, useState } from 'react';

type HookReturnValue = {
  suppressNoRowsOverlay: boolean;
};

export default <T>(gridApiRef: RefObject<GridApi>, params: { isLoading: boolean; data?: T[] }): HookReturnValue => {
  const { isLoading, data } = params;
  // Suppressing overlay because table shows it by default before loading data
  const [suppressNoRowsOverlay, setSuppressNoRowsOverlay] = useState(true);

  useEffect(() => {
    if (isLoading) {
      // Not sure why timeouts are needed, but it something that I found in ag-grid github issue tracker
      // https://github.com/ag-grid/ag-grid/issues/3849#issuecomment-1474747809
      setTimeout(() => gridApiRef.current?.showLoadingOverlay());
    } else if (data?.length === 0) {
      setSuppressNoRowsOverlay(false);
    } else {
      gridApiRef.current?.hideOverlay();
    }
  }, [isLoading, data]);

  useEffect(() => {
    if (!suppressNoRowsOverlay) {
      setTimeout(() => gridApiRef.current?.showNoRowsOverlay());
    }
  }, [suppressNoRowsOverlay]);

  return { suppressNoRowsOverlay };
};
